import React, { Component } from "react";
import { View } from "react-native";
import { Switch } from "react-router-dom";

import Login from "views/UserAuth/Login";
import Register from "views/UserAuth/Register";
import ForgotPassword from "views/UserAuth/ForgotPassword";
import SplashScreen from "views/SplashScreen";
import Home from "views/Home";
import Connect from "views/DeviceAuth/Connect";
import ConnectSuccess from "views/DeviceAuth/ConnectSuccess";
import ConnectPoll from "views/DeviceAuth/ConnectPoll";
import ConnectConfirm from "views/DeviceAuth/ConnectConfirm";
import DeviceAuth from "views/DeviceAuth";
import PasswordReset from "views/PasswordReset";
import Notfound from "views/Notfound";
import DeviceSetting from "views/DeviceSetting";
import Timer from "views/Timer";
import UnitDetail from "views/UnitDetail";
import UserDetail from "views/UserAuth/UserDetail";
import AddDevice from "views/AddDevice";

import Route from "Navigation/AuthRoute";

const Navigation = () => {
	return (
		<Switch>
			<Route exact path="/" component={Home} />
			<Route path="/login" component={Login} />
			<Route path="/register" component={Register} />
			<Route path="/forgot" component={ForgotPassword} />
			<Route exact path="/connect" component={Connect} />
			<Route path="/connect/success/:deviceId" component={ConnectSuccess} />
			<Route path="/connect/poll/:deviceId" component={ConnectPoll} />
			<Route path="/connect/confirm" component={ConnectConfirm} />
			<Route path="/deviceregister" component={DeviceAuth} />
			<Route path="/passwordReset/:username/:token" component={PasswordReset} />
			<Route path="/devicesetting" component={DeviceSetting} />
			<Route path="/unitdetail" component={UnitDetail} />
			<Route path="/userdetail" component={UserDetail} />
			<Route path="/adddevice" component={AddDevice} />
			<Route path="/timer" component={Timer} />
			<Route component={Notfound} />
		</Switch>
	);
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation/index.web.js